import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsPayments1V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64 34H34V64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M1.11759e-07 30H30V4.32134e-07" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
